import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { Car, Lock } from 'lucide-react';
import toast from 'react-hot-toast';
import { useAuth } from '../../../contexts/AuthContext';
import { usePageSeo } from '../../../hooks/usePageSeo';

export default function AutomobileLoginPage() {
  usePageSeo({
    title: 'Otomobil yönetim girişi',
    description: 'Otomobil kataloğu yönetim paneli',
    keywords: '',
    noindex: true,
  });

  const { user, signIn } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) {
    return <Navigate to="/otomobil/admin" replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!username || !password) {
        throw new Error('Kullanıcı adı ve şifre gereklidir');
      }
      await signIn(username, password);
      toast.success('Giriş başarılı');
      navigate('/otomobil/admin');
    } catch (error: unknown) {
      const msg =
        error instanceof Error ? error.message?.toLowerCase() || '' : '';
      const errorMessage =
        msg.includes('invalid') || msg.includes('geçersiz') || msg.includes('credentials')
          ? 'Kullanıcı adı veya şifre hatalı'
          : 'Giriş işlemi sırasında bir hata oluştu';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 to-indigo-100 dark:from-gray-900 dark:to-gray-800 p-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-indigo-100 dark:bg-indigo-900 mb-4">
            <Car className="w-8 h-8 text-indigo-600 dark:text-indigo-400" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Otomobil Yönetimi</h2>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            Marka, model ve görsel yönetimi — forum panelinden bağımsız
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="auto-username"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300"
            >
              Kullanıcı Adı
            </label>
            <input
              id="auto-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1 block w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:text-white"
              required
              autoComplete="username"
            />
          </div>

          <div>
            <label
              htmlFor="auto-password"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300"
            >
              Şifre
            </label>
            <input
              id="auto-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full px-3 py-2 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:text-white"
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
          >
            {loading ? 'Giriş yapılıyor…' : 'Panele Giriş'}
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-gray-500 dark:text-gray-400">
          <Link to="/otomobil" className="text-indigo-600 dark:text-indigo-400 hover:underline">
            ← Otomobil kataloğu
          </Link>
          <span className="mx-2">·</span>
          <Link to="/login" className="hover:underline">
            Forum yönetimi
          </Link>
        </p>
      </div>
    </div>
  );
}
